export default __webpack_public_path__ + "static/media/tete41.7bf9f671.png";